<template>
  <ModalForm
    :title="title"
    :subtitle="subtitle"
    text-btn-confirm="Печать"
    only-btn-submit
    :disabled-btn-submit="disabledBtnSubmit"
    :btn-size="btnSize"
    @request="onRequest"
    @reject="onReject"
  >
    <div class="d-flex flex-col gap-s mb-30">
      <RadioGroup
        :options="printOptions"
        name="type"
        :value="initPrintType"
        :class="{ 'd-none': (printOptions.length <= 1) }"
      />

      <slot/>
    </div>
    <template v-slot:customBtn>
      <slot name="customBtn" />
    </template>
  </ModalForm>

</template>

<script>
import ModalForm from '@/components/ui/Modal/ModalForm'
import RadioGroup from '@/components/Form/Radio/RadioGroup'
import { openPrint } from '@/utils/print/openPrint'
import { showAlertWarning } from '@/utils/store/alert'
import mediaService from '@/services/media.service'

export default {
  name: 'ModalPrint',
  components: { RadioGroup, ModalForm },
  props: {
    title: {
      type: String,
      default: 'Печать'
    },
    printParams: {
      type: [Object, null],
      default: null
    },
    printOptions: {
      type: Array,
      required: true
    },
    initPrintType: {
      type: String,
      default: ''
    },
    disabledBtnSubmit: {
      type: Boolean,
      required: false,
      default: false
    },
    btnSize: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    }
  },
  methods: {
    async onRequest (data) {
      if (!data.type) {
        showAlertWarning('Пожалуйста, выберете тип документа для печати')
      }

      if (!this.printParams) {
        return this.$emit('request', data)
      }

      try {
        this.$store.commit('SET_IS_SENDING_REQUEST_MODAL')
        const response = await openPrint(data.type, this.printParams)

        if (response?.status !== 200) return

        const file = mediaService.createFileFromResponse(response)
        this.$emit('request', file)
      } finally {
        this.$store.commit('SET_IS_SENDING_REQUEST_MODAL', false)
      }
    },

    onReject () {
      this.$emit('reject')
    }
  }
}
</script>
